<template>
  <div>
    <!-- Header -->
    <div class="relative flex justify-center items-center">
      <div class="absolute z-30 text-white px-6">
        <h1 class="text-4xl md:text-5xl leading-[50px] md:leading-[60px] font-serif text-center">{{ $t('services.training-paths.title') }}</h1>
      </div>
      <div class="absolute z-20 inset-0 bg-black opacity-40"></div>
      <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" class="object-cover min-h-[400px] w-full md:aspect-[3]" src="/images/services/training-paths-hero.jpg"
        :alt="$t('services.training-paths.title')" />
    </div>

    <!-- Main Content -->
    <div class="container mx-auto px-6 py-12">
      <p class="text-sm md:text-base text-gray-600 mb-12 max-w-4xl">
        {{ $t('services.training-paths.description') }}
      </p>

      <h2 class="text-xl md:text-2xl font-serif mb-8">{{ $t('services.training-paths.areas.title') }}</h2>
      <div class="grid md:grid-cols-2 gap-12">
        <div class="bg-white rounded-lg p-8 shadow-lg">
          <h3 class="text-xl md:text-2xl font-serif mb-6">{{ $t('services.training-paths.areas.educators.title') }}</h3>
          <ul class="space-y-3 text-sm md:text-base">
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-orange-600 shrink-0" />
              {{ $t('services.training-paths.areas.educators.classroom') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-orange-600 shrink-0" />
              {{ $t('services.training-paths.areas.educators.strategies') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-orange-600 shrink-0" />
              {{ $t('services.training-paths.areas.educators.inclusion') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-orange-600 shrink-0" />
              {{ $t('services.training-paths.areas.educators.communication') }}
            </li>
          </ul>
          <!-- <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" src="/images/services/training-paths-educators.jpg"
            :alt="$t('services.training-paths.areas.educators.title')"
            class="mt-8 rounded-lg w-full h-64 object-cover" /> -->
        </div>

        <div class="bg-white rounded-lg p-8 shadow-lg">
          <h3 class="text-xl md:text-2xl font-serif mb-6">{{ $t('services.training-paths.areas.parents.title') }}</h3>
          <ul class="space-y-3 text-sm md:text-base">
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-orange-600 shrink-0" />
              {{ $t('services.training-paths.areas.parents.parenting') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-orange-600 shrink-0" />
              {{ $t('services.training-paths.areas.parents.communication') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-orange-600 shrink-0" />
              {{ $t('services.training-paths.areas.parents.conflicts') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-orange-600 shrink-0" />
              {{ $t('services.training-paths.areas.parents.development') }}
            </li>
          </ul>
          <!--<nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" src="/images/services/training-paths-parents.jpg"
            :alt="$t('services.training-paths.areas.parents.title')" class="mt-8 rounded-lg w-full h-64 object-cover" /> -->
        </div>
      </div>

      <div class="grid md:grid-cols-2 gap-12 mt-12 p-8 shadow-lg">
        <div>
          <h2 class="text-xl md:text-2xl font-serif mb-6">{{ $t('services.training-paths.methodology.title') }}</h2>
          <p class="text-sm md:text-base text-gray-600">
            {{ $t('services.training-paths.methodology.description') }}
          </p>
          <ul class="mt-6 space-y-3 text-sm md:text-base">
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-orange-600 shrink-0" />
              {{ $t('services.training-paths.methodology.workshops') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-orange-600 shrink-0" />
              {{ $t('services.training-paths.methodology.case-studies') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-orange-600 shrink-0" />
              {{ $t('services.training-paths.methodology.group') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-orange-600 shrink-0" />
              {{ $t('services.training-paths.methodology.exercises') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-orange-600 shrink-0" />
              {{ $t('services.training-paths.methodology.courses') }}
            </li>
          </ul>
        </div>
        <!--<nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" src="/images/services/training-paths-methodology.jpg"
          :alt="$t('services.training-paths.methodology.title')" class="rounded-lg w-full h-64 object-cover" /> -->
      </div>

      <!-- Contact Section -->
      <div class="bg-gray-100 p-8 rounded-lg mt-16">
        <h2 class="text-xl md:text-2xl font-serif mb-4">{{ $t('services.training-paths.contact.title') }}</h2>
        <p class="text-sm md:text-base text-gray-600 mb-8">
          {{ $t('services.training-paths.contact.description') }}
        </p>
        <div class="flex flex-col md:flex-row gap-4">
          <NuxtLink :to="localePath('/contacts')">
            <Button class="bg-orange-600 text-white px-6 py-3 w-full xl:w-auto">
              {{ $t('services.training-paths.contact.courses-btn') }}
            </Button>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>
